@let info = path | fieldInfo: collection;
<span class="field-head">
  <span class="field-label">{{ label || info.label }}</span>
  <code class="field-path">{{ info.path }}</code>
</span>

@if (info.hint) {
<span class="field-hint">{{ info.hint }}</span>
}